export default "__VITE_ASSET__HW7D9KBB__"